import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function GoogleAnalytics() {
  const location = useLocation();
  const TRACKING_ID = process.env.REACT_APP_GA_ID || '';

  useEffect(() => {
    // Don't load if no tracking ID is set
    if (!TRACKING_ID) {
      console.warn('Google Analytics: REACT_APP_GA_ID not set in environment variables');
      return;
    }

    // Load the Google Analytics script
    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=${TRACKING_ID}`;
    script.async = true;
    document.head.appendChild(script);

    // Initialize gtag
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    gtag('js', new Date());
    gtag('config', TRACKING_ID, {
      page_path: location.pathname,
    });

    window.gtag = gtag;
  }, [TRACKING_ID]);

  useEffect(() => {
    // Track page views when route changes
    if (!TRACKING_ID || !window.gtag) return;

    window.gtag('event', 'page_view', {
      page_path: location.pathname,
      page_title: document.title,
    });
  }, [location, TRACKING_ID]);

  return null;
}

export default GoogleAnalytics;
